import React, {Component} from 'react';
import { InputLabel, MenuItem, Select, TextField, withStyles} from '@material-ui/core';
import {connect} from 'react-redux';
import {Dispatch} from 'redux';
import { USER_CONTACT_FORM } from '../../core/handlers.actions';
import { IWall } from '../../core/models/wall';
import { FormControl } from '@material-ui/core';
import USStates from '../../core/helpers/states.json';

const styles = (theme:any) => ({
    root: {
        paddingLeft: '23px', 
        width: 230,
        '&  .MuiInput-root': {fontSize: 16},
        '& .MuiFormLabel-root': {fontSize: 16}        
    },
    formControl: {
        width: 167,
    }
});

interface Props {
    classes:any;
    type:string;
    updateFormValidation: (validation:any) => void;
    wall: IWall;
}

interface State {
    firstName: string | null;
    lastName: string | null;
    email: string | null;
    zip: number | null;
    address: string | null;
    address2: string | null;
    city: string | null;
    state: string | null;
}

class ContactInfo extends Component<Props, State> {
    state:State = {firstName:null, lastName:null, email:null, zip: null, address: null, address2: null, city:null, state:''};
    constructor(props:any){
        super(props);
        this.inputChangeHandler = this.inputChangeHandler.bind(this);
        this.validForm = this.validForm.bind(this);
    }

    public inputChangeHandler(e:any){
        const {updateFormValidation} = this.props;
        const {name, value} = e.target;        
        this.setState({...this.state, [name]:value});
        setTimeout(() => {
            const data = {
                isValid: this.validForm(this.state),
                user: this.state
            };
            updateFormValidation(data);
        }, 300);        
        
    }

    public validForm(state:any){    
        const {postRequiresUserFullAddress} = this.props.wall || false;    
        // Validate all keys if one fails thow an error.
        for(const [key, value] of Object.entries(state)){
            /** check for standar values */
            if(!postRequiresUserFullAddress) {
                switch(key){
                    case 'firstName':
                    case 'lastName':
                    case 'email':
                    case 'zip':
                        if( value === '' || value === null) return false; // Only check for user items zip not required    
                        break;
                    default:
                        break;
                }
            } else if(key !== 'address2') {                
                if(value === '' || value === null) return false;    // All fields required except for address2
            }                          
        }
        return true;
    }

    public render(){
        const {classes, type, } = this.props;
        const {postRequiresUserFullAddress} = this.props.wall || false;
        const {firstName, lastName, email, zip, address, address2, city, state} = this.state;

        return(
            <div className={classes.root}>
                <TextField onChange={this.inputChangeHandler} defaultValue={firstName}  margin="dense" name="firstName" label="First Name" type="text" required={type==='Yes'}/>
                <TextField onChange={this.inputChangeHandler} defaultValue={lastName}  margin="dense" name="lastName" label="Last Name" type="text" required={type==='Yes'}/>
                <TextField onChange={this.inputChangeHandler} defaultValue={email}  margin="dense" name="email" label="Email Address" type="email" required={type==='Yes'}/>
                {postRequiresUserFullAddress?
                (<div>
                    <TextField onChange={this.inputChangeHandler} defaultValue={address}  margin="dense" name="address" label="Address" type="text" required={type==='Yes'}/>
                    <TextField onChange={this.inputChangeHandler} defaultValue={address2}  margin="dense" name="address2" label="Address 2" type="text" />
                    <TextField onChange={this.inputChangeHandler} defaultValue={city}  margin="dense" name="city" label="City" type="text" required={type==='Yes'}/>
                    <FormControl className={classes.formControl} required>
                        <InputLabel id="state-select">State</InputLabel>
                        <Select value={state} labelId="state-select" name="state" onChange={this.inputChangeHandler}>
                            {USStates.map((state:any) => <MenuItem key={state.abbreviation} value={state.abbreviation}>{state.name}</MenuItem>)}
                        </Select>
                    </FormControl>
                </div>)
                :null}
                <TextField onChange={this.inputChangeHandler} defaultValue={zip}  margin="dense" name="zip" label="Zip / Postal code" type="zip" required={true}/>                       
            </div>
        );
    }
}

const mapProps = (app:any) => ({wall: app.rootReducer.wall});
const mapDispatch = (dispatch:Dispatch) => ({
    updateFormValidation: (validation:any) => dispatch({type: USER_CONTACT_FORM, payload: validation})
});
export default connect(mapProps, mapDispatch)(withStyles(styles)(ContactInfo));